export default __webpack_public_path__ + "static/media/word_preview.d253aa16.svg";